<div class="ai-bubble hide-in-print" *ngIf="!hidden">

	<!-- Compact chat panel -->
	<div class="ai-bubble__panel" *ngIf="open">
		<div class="ai-bubble__bar">
			<span class="ai-bubble__title">AI Data Analyst</span>
			<div class="ai-bubble__bar-actions">
				<button type="button" class="ai-bubble__icon" title="New chat" (click)="newChat()" aria-label="New chat">
					<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
						<path d="M12 5v14M5 12h14"></path>
					</svg>
				</button>
				<button type="button" class="ai-bubble__icon" title="Open full page" (click)="expand()" aria-label="Expand to full page">
					<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
						<path d="M15 3h6v6M21 3l-9 9M9 21H3v-6M3 21l9-9"></path>
					</svg>
				</button>
				<button type="button" class="ai-bubble__icon" title="Close" (click)="close()" aria-label="Close">
					<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
						<path d="M18 6 6 18M6 6l12 12"></path>
					</svg>
				</button>
			</div>
		</div>
		<div class="ai-bubble__body">
			<cs-chat
				[messages]="messages"
				[busy]="busy"
				[contextUsage]="contextUsage"
				[debugEnabled]="canDebug"
				[debugContext]="debugContext"
				(debugRequested)="onDebugRequested()"
				(send)="onSend($event)"
				(stop)="onStop()"></cs-chat>
		</div>
	</div>

	<!-- Launcher -->
	<button type="button" class="ai-bubble__launcher" (click)="toggle()"
			[class.ai-bubble__launcher--open]="open"
			[attr.aria-expanded]="open" aria-label="AI Data Analyst">
		<svg *ngIf="!open" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
			<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
		</svg>
		<svg *ngIf="open" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
			<path d="M18 6 6 18M6 6l12 12"></path>
		</svg>
	</button>
</div>
